var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Upload a NIEM mapping spreadsheet")]),
      _c("br"),
      _c("p", [
        _vm._v("See the "),
        _c(
          "b",
          [_c("b-link", { attrs: { to: "/about" } }, [_vm._v("About")])],
          1
        ),
        _vm._v(
          " page for more information about the NIEM mapping spreadsheet and to download the template and example."
        )
      ]),
      _c("b-form-file", {
        attrs: { id: "file", accept: ".xlsx", placeholder: "Choose a file..." },
        on: {
          change: function($event) {
            return _vm.loadUserFile($event)
          }
        }
      }),
      _c(
        "button",
        {
          staticClass:
            "btn btn-sm btn-outline-secondary dropdown-toggle pull-right",
          attrs: { type: "button", id: "demo", "data-toggle": "dropdown" }
        },
        [_vm._v("Demo")]
      ),
      _c(
        "div",
        { staticClass: "dropdown-menu", attrs: { "aria-labelledby": "demo" } },
        _vm._l(_vm.demos, function(demo) {
          return _c(
            "a",
            {
              key: demo.id,
              staticClass: "dropdown-item",
              on: {
                click: function($event) {
                  return _vm.loadExampleFile(demo.fileName)
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-fw",
                class: demo.classes,
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v("\n      " + _vm._s(demo.text) + "\n\n    ")
            ]
          )
        }),
        0
      ),
      _c("br"),
      _c("div", { key: _vm.render }, [
        _c(
          "div",
          [
            _c("hr"),
            _c("div", [
              _c("h2", [_vm._v("Status")]),
              _c(
                "div",
                {
                  staticClass: "btn-group align-with-header",
                  attrs: { role: "group" }
                },
                [
                  _vm.fileIsSample
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-sm",
                          attrs: {
                            download: "",
                            href: "/examples/" + _vm.fileName
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-fw fa-download" }),
                          _vm._v(" Download demo\n          ")
                        ]
                      )
                    : _vm._e(),
                  _vm.results.length > 0
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          on: { click: _vm.saveResults }
                        },
                        [
                          _c("i", { staticClass: "fa fa-fw fa-download" }),
                          _vm._v(" Download results\n          ")
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]),
            _c("br"),
            _c(
              "div",
              { key: _vm.render, class: ["alert", _vm.statusAlertClass] },
              [
                _c("h4", { staticClass: "mb-0" }, [
                  _c("i", {
                    staticClass: "fa fa-fw",
                    class: _vm.statusIconClass
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.statusPanel.stage) +
                      " of 3: " +
                      _vm._s(_vm.statusPanel.label) +
                      "\n\n          "
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm pull-right pt-0 pb-0",
                      attrs: {
                        "data-toggle": "collapse",
                        "data-target": "#statusExpanded"
                      },
                      on: {
                        click: function($event) {
                          _vm.statusPanel.expand = !_vm.statusPanel.expand
                        }
                      }
                    },
                    [
                      _vm.statusPanel.expand
                        ? _c("i", { staticClass: "fa fa-fw fa-minus" })
                        : _c("i", { staticClass: "fa fa-fw fa-plus" })
                    ]
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "collapse show",
                    attrs: { id: "statusExpanded" }
                  },
                  [
                    _c("hr"),
                    _c("p", [_vm._v(_vm._s(_vm.statusPanel.description))]),
                    _c("strong", [
                      _c("p", [_vm._v(_vm._s(_vm.statusPanel.error))])
                    ])
                  ]
                )
              ]
            ),
            _vm.results
              ? _c("b-table", {
                  attrs: {
                    small: "",
                    striped: "",
                    hover: "",
                    items: _vm.results,
                    fields: _vm.fields
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "status",
                        fn: function(data) {
                          return [
                            _c("i", {
                              class: _vm.getIssueSeverityIconClasses(
                                data.item.severity
                              )
                            })
                          ]
                        }
                      },
                      {
                        key: "more...",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "outline-secondary",
                                  size: "sm"
                                },
                                on: { click: row.toggleDetails }
                              },
                              [
                                row.detailsShowing
                                  ? _c("i", {
                                      staticClass: "fa fa-fw fa-caret-up"
                                    })
                                  : _c("i", {
                                      staticClass: "fa fa-fw fa-caret-down"
                                    })
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "row-details",
                        fn: function(row) {
                          return [
                            _c("b-card", [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(_vm.getSpreadsheetLocation(row.item))
                                )
                              ]),
                              _c("p", [
                                _vm._v("Label: " + _vm._s(row.item.label))
                              ]),
                              _c("p", [_vm._v("NDR: " + _vm._s(row.item.NDR))]),
                              _c("p", [
                                _vm._v(
                                  "Component: " + _vm._s(row.item.component)
                                )
                              ]),
                              _c("p", [
                                _vm._v("Field: " + _vm._s(row.item.field))
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Applicability: " +
                                    _vm._s(row.item.applicability)
                                )
                              ]),
                              _c("p", [
                                _vm._v("Severity: " + _vm._s(row.item.severity))
                              ]),
                              _c("p", [
                                _vm._v(
                                  "Problem value: " +
                                    _vm._s(row.item.problemValue)
                                )
                              ])
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3209634654
                  )
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }